// extracted by mini-css-extract-plugin
export default {"qrReader":"QrReaderPage_qrReader__Qb-34"};